export default function(object){
    return JSON.parse(JSON.stringify(object))
}